import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="slug-editor"
export default class extends Controller {
  static targets = ["field", "icon"]
  static values = {
    editing: { type: Boolean, default: false }
  }

  connect() {
    // Apply initial disabled styling
    if (!this.editingValue) {
      this.applyDisabledStyling()
    }
  }

  toggle() {
    this.editingValue = !this.editingValue
    this.updateView()
  }

  updateView() {
    if (this.editingValue) {
      // Enable editing
      this.fieldTarget.disabled = false
      this.fieldTarget.focus()
      this.fieldTarget.select()
      this.removeDisabledStyling()
      this.iconTarget.innerHTML = this.checkIconSvg
      this.element.querySelector('button').classList.add('bg-green-50', 'dark:bg-green-900', 'text-green-600', 'dark:text-green-400')
      this.element.querySelector('button').classList.remove('bg-gray-50', 'dark:bg-gray-700', 'text-gray-600', 'dark:text-gray-400')
    } else {
      // Disable editing
      this.fieldTarget.disabled = true
      this.applyDisabledStyling()
      this.iconTarget.innerHTML = this.pencilIconSvg
      this.element.querySelector('button').classList.remove('bg-green-50', 'dark:bg-green-900', 'text-green-600', 'dark:text-green-400')
      this.element.querySelector('button').classList.add('bg-gray-50', 'dark:bg-gray-700', 'text-gray-600', 'dark:text-gray-400')
    }
  }

  applyDisabledStyling() {
    this.fieldTarget.classList.add('bg-gray-100', 'dark:bg-gray-700', 'text-gray-500', 'dark:text-gray-600', 'cursor-not-allowed')
    this.fieldTarget.classList.remove('bg-white', 'dark:bg-gray-900')
  }

  removeDisabledStyling() {
    this.fieldTarget.classList.remove('bg-gray-100', 'dark:bg-gray-700', 'text-gray-500', 'dark:text-gray-600', 'cursor-not-allowed')
    this.fieldTarget.classList.add('bg-white', 'dark:bg-gray-900')
  }

  get pencilIconSvg() {
    return `
      <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z"></path>
      </svg>
    `
  }

  get checkIconSvg() {
    return `
      <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
      </svg>
    `
  }
}
